namespace GeniuzPOS.AdvPromo {
    export interface Adv05HdRow {
        PromoCampaign?: string;
        PromoCampName?: string;
        PmExtCode?: string;
        PmId?: string;
        PmDesc?: string;
        PmGroupId?: string;
        PromoApproveFg?: number;
        PmGroupDesc?: string;
        PmType?: number;
        PPtype?: number;
        PmTypeDesc?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: number;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: number;
        PromoDay?: string;
        PromoShopFg?: number;
        PromoShop?: string;
        PromoCustFg?: number;
        PromoCust?: string;
        VenderSharing?: number;
        PromoStatus?: PostStatus;
        ItemList?: Adv05ItemDetailRow[];
        ItemExList?: Adv05ItemExDtRow[];
    }

    export namespace Adv05HdRow {
        export const idProperty = 'PmId';
        export const nameProperty = 'PromoCampaign';
        export const localTextPrefix = 'AdvPromo.Adv05Hd';
        export const lookupKey = 'AdvPromo.Adv05Hd';

        export function getLookup(): Q.Lookup<Adv05HdRow> {
            return Q.getLookup<Adv05HdRow>('AdvPromo.Adv05Hd');
        }
        export const deletePermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const insertPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const updatePermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';

        export declare const enum Fields {
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            PmExtCode = "PmExtCode",
            PmId = "PmId",
            PmDesc = "PmDesc",
            PmGroupId = "PmGroupId",
            PromoApproveFg = "PromoApproveFg",
            PmGroupDesc = "PmGroupDesc",
            PmType = "PmType",
            PPtype = "PPtype",
            PmTypeDesc = "PmTypeDesc",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoCust = "PromoCust",
            VenderSharing = "VenderSharing",
            PromoStatus = "PromoStatus",
            ItemList = "ItemList",
            ItemExList = "ItemExList"
        }
    }
}
